module.exports = __webpack_public_path__ + "img/foot_sx.d0cf98f7.png";